// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._15a5nqa1{border-top-style:solid}\n._1bsb1osq{width:100%}\n._1i53muej{border-top-color:var(--ds-border,#091e4224)}\n._uwhke4h9{border-top-width:var(--ds-border-width,1px)}", ""]);
// Exports
module.exports = exports;
